export enum MutationTypes {
  /**falg表单提交内容*/
  'QUESTIONNAIRE_FLAG_CONTENT_SAVE' = 'questFlagContentSave',
}
